import { StandData } from 'opensolar-pageeditor'
import { Link, styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const Banner = styled('div', { name: 'Banner' })<{
  backgroundUrl: string
}>(({ backgroundUrl }) => ({
  marginTop: 30,
  height: 90,
  borderRadius: 8,
  backgroundImage: backgroundUrl ? `url("${backgroundUrl}")` : '',
  padding: '15px 30px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: backgroundUrl ? '' : 'white',
}))
const CoverLogo = styled('img', { name: 'CoverWrapper' })({
  marginRight: 'auto',
  maxHeight: 40,
  maxWidth: 75,
})
const CoverTagline = styled('p', { name: 'CoverTagline', shouldForwardProp: (prop) => prop !== 'white' })<{
  white?: boolean
}>(({ white }) => ({
  margin: '5px 0',
  fontSize: 14,
  color: white ? 'white' : 'black',
}))

const ActionBtn = styled(Link, { name: 'ActionBtn', shouldForwardProp: (prop) => prop !== 'white' })<{
  white?: boolean
}>(({ white }) => ({
  backgroundColor: '#4272DD',
  fontSize: 14,
  padding: '6px 10px',
  borderRadius: 4,
  color: `${white ? 'white' : 'black'} !important`,
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: '#113B98',
  },
}))

const ExpoBanner: FC<StandData> = ({ expoStand, org }) => {
  const translate = useTranslate()
  const bgUrl = expoStand?.contents?.assets?.cover_background
  const logoUrl = expoStand?.brand_content?.logo_contents || org?.logo_public_url
  const coverElement = expoStand?.contents?.elements?.find((x) => x.contentType === 'cover')
  const coverData = coverElement?.contentType === 'cover' ? coverElement.data : undefined
  const tagline = coverData?.tagline
  const whiteText = coverData?.whiteText
  if (!bgUrl && !logoUrl && !tagline) return null
  return (
    <Banner backgroundUrl={bgUrl || ''}>
      <CoverLogo src={logoUrl?.toString()} />
      <CoverTagline white={whiteText}>{tagline}</CoverTagline>
      <div>
        <ActionBtn
          white={whiteText}
          target="_blank"
          rel="noopener noreferrer"
          href={'/expo/' + expoStand?.brand_content?.slug}
        >
          {translate('Visit %{brandName} Stand', { brandName: expoStand?.brand_content?.name })}
        </ActionBtn>
      </div>
    </Banner>
  )
}

export default ExpoBanner
